import React from 'react';
import {
	AirportCodeHolidayCheck,
	AirportCodeKey,
	AirportCodeTravelSupermarket,
} from '@app/model/market_state/AirportCode';
import MenuButtonFilter, { MenuButtonFilterItem } from '@app/component/menu/MenuButtonFilter';
import ParityFilterInput from '@app/model/parity/input/ParityFilterInput';


type ParityFilterAirportCodeCheckFilterProps = {
	filter: ParityFilterInput;
	onFilter: (filter: ParityFilterInput) => void;
};

export const ParityFilterAirportCodeCheckFilter = React.memo(
	function DashboardSelectAirportCodeCheckFilter({ filter, onFilter }: ParityFilterAirportCodeCheckFilterProps) {


		const menuItems: MenuButtonFilterItem<AirportCodeKey>[] = [
			...Object.entries(AirportCodeTravelSupermarket),
			...Object.entries(AirportCodeHolidayCheck),
		].map(([value, airport]) => ({
			value: value as AirportCodeKey,
			name: airport.name,
		}));


		const onSelect = (value: AirportCodeKey | undefined) => {
			onFilter({
				...filter,
				airportCode: value,
			});
		};

		return <MenuButtonFilter menuItems={menuItems}
														 selectedValue={filter.airportCode}
														 onSelect={onSelect}
														 menuDescription="Please select the airport"
														 enableSearch
														 searchPlaceholder="Filter airports" />;

	});
